import * as yup from "yup";
import { SupportedLanguage } from "./features/intl/SupportedLanguage";

const validLanguages = Object.values(SupportedLanguage);

export const envValidationSchema = yup.object({
  BASE_URL: yup.string().required(),
  TOS_API_URL: yup.string().required(),
  DISABLE_LOGS: yup.boolean().default(false),
  ENVIRONMENT_NAME: yup.string().required(),
  TOS_URL: yup.string().url("TOS_URL must be a valid URL").required(),
  SENTRY_DSN: yup.string().url("SENTRY_DSN must be a valid URL"),
  LANGUAGE: yup.string().oneOf(validLanguages).required(),
  OIDC_CLIENT_ID: yup.string().required(),
  OIDC_DISCOVERY_URL: yup.string().required(),
  OIDC_SCOPES: yup.array(yup.string()).min(1).required(),
  // Not used for now
  SUPPORT_PHONE_NUMBER_COUNTRY_CODE: yup.string().required(),
  SUPPORT_PHONE_NUMBER: yup.string().required(),
});

export const environmentValues = {
  BASE_URL: process.env.EXPO_PUBLIC_BASE_URL,
  TOS_API_URL: process.env.EXPO_PUBLIC_TOS_API_URL,
  DISABLE_LOGS: process.env.EXPO_PUBLIC_DISABLE_LOGS,
  ENVIRONMENT_NAME: process.env.EXPO_PUBLIC_ENVIRONMENT_NAME,
  TOS_URL: process.env.EXPO_PUBLIC_TOS_URL,
  SENTRY_DSN: process.env.EXPO_PUBLIC_SENTRY_DSN,
  LANGUAGE: process.env.EXPO_PUBLIC_LANGUAGE,
  OIDC_CLIENT_ID: process.env.EXPO_PUBLIC_OIDC_CLIENT_ID,
  OIDC_DISCOVERY_URL: process.env.EXPO_PUBLIC_OIDC_DISCOVERY_URL,
  OIDC_SCOPES: process.env.EXPO_PUBLIC_OIDC_SCOPES?.split(","),
  SUPPORT_PHONE_NUMBER_COUNTRY_CODE:
    process.env.EXPO_PUBLIC_SUPPORT_PHONE_NUMBER_COUNTRY_CODE,
  SUPPORT_PHONE_NUMBER: process.env.EXPO_PUBLIC_SUPPORT_PHONE_NUMBER,
};

function validateEnvironment() {
  try {
    const env = envValidationSchema.validateSync(environmentValues);

    return env;
  } catch (error: any) {
    throw new Error(
      `.env.local file missing or invalid. Do you have a \`.env.local\` file in the root of your project? You can copy a config from .env.development and save into .env.local, then rebuild your app. \n\nError: ${
        error?.message ?? error
      }`,
    );
  }
}

export const environment = validateEnvironment();
